import React from "react";
import "./style.css";
import { assets } from "../../../assets/assets";
function Spin({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="spin-modal-overlay"
      onClick={onClose} // الضغط على الخلفية يقفل المودال
    >
      <div
        className="spin-modal col-lg-7 col-10"
        onClick={(e) => e.stopPropagation()} // منع الغلق عند الضغط على المودال نفسه
      >
        <div className="header-spin">
            <p className="m-0 p-0">Spin 360</p>
          <button className="close-btn-" onClick={onClose}>
            <img src={assets.close_circle} alt="" />
          </button>
        </div>
        <div className="img-spin">
         <img src={assets.imgspin} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Spin;
